<script>
import CockpitMatryoshkaItemOperations
from '@/components/cockpit/matryoshka/operations/CockpitMatryoshkaItemOperations.vue';

export default {
  name: 'CockpitMatryoshkaItemOperationsTab',
  props: {
    labelArchiveId: Number,
  },
  emits: [
    'operation-success',
  ],
  components: { CockpitMatryoshkaItemOperations },
};
</script>

<template>
  <CockpitMatryoshkaItemOperations
    :label-archive-id="labelArchiveId"
    @operation-success="$emit('operation-success', $event)"
  />
</template>

<style scoped lang="scss">

</style>
